import React, { Component } from 'react';
import { Row, Col, Form, Nav, Tab } from "react-bootstrap";
import { FaList } from 'react-icons/fa';
import Side from "./Sidebar";
import Top from "./Topbar";
import Loader from "./LoaderModal";
import AnalyticsReport from './AnalyticsReport';
import ProgressionReport from './ProgressionReport';
import C from '../lib/Config';
import swal from 'sweetalert';

export default class Analytics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: '',
            progressionSearchQuery: '',
            filteredPatientsInfo: [], // Separate state for filtered patients in Information tab
            filteredPatientsProgression: [], // Separate state for filtered patients in Progression tab
            loaderModal: false,
            activeCaseData: [],
            selectedPatientInfo: null, // Separate selected patient for Information tab
            selectedPatientProgression: null, // Separate selected patient for Progression tab
            activeTab: 'first',
        };
        this.handleSearch = this.handleSearch.bind(this);
        this.handleProgressionSearch = this.handleProgressionSearch.bind(this);
        this.getActiveCases = this.getActiveCases.bind(this);
        this.selectPatient = this.selectPatient.bind(this);
        this.handleTabSelect = this.handleTabSelect.bind(this);
    }

    handleSearch(event) {
        const query = event.target.value.toLowerCase();
        this.setState({ searchQuery: query });

        if (query.length > 0) {
            const filteredPatients = this.state.activeCaseData.filter(patient =>
                patient.name.toLowerCase().includes(query)
            );
            this.setState({ filteredPatientsInfo: filteredPatients });
        } else {
            this.setState({ filteredPatientsInfo: [] });
        }
    }

    handleProgressionSearch(event) {
        const query = event.target.value.toLowerCase();
        this.setState({ progressionSearchQuery: query });

        if (query.length > 0) {
            const filteredPatients = this.state.activeCaseData.filter(patient =>
                patient.name.toLowerCase().includes(query)
            );
            this.setState({ filteredPatientsProgression: filteredPatients });
        } else {
            this.setState({ filteredPatientsProgression: [] });
        }
    }

    getActiveCases() {
        let loggedInuser = localStorage.getItem("userId");
        let data = JSON.parse(localStorage.getItem('userRoleDto'));
        let roleIdFromCache = data.roleId;

        let url = '';
        if (roleIdFromCache === 3) {
            url = `${C.getUrl()}/userCase/getPatientRegistrationListForStaff?userId=${loggedInuser}&status=A`;
        } else {
            url = `${C.getUrl()}/userCase/getPatientRegistrationList?doctorId=${loggedInuser}&status=A`;
        }
        return fetch(url, {
            method: 'GET',
            mode: 'cors',
        })
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let error = resObj.subErrors;
                if (error !== 'undefined' && error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    let obj = resObj.message;
                    if (obj === 'No record found.') {
                        this.setState({ activeCaseData: [] });
                    } else {
                        let tempData = JSON.parse(resObj.message);
                        let activeCaseData = tempData.map(obj => ({
                            name: `${obj.firstName} ${obj.lastName}`,
                            patientID: obj.patientID
                        }));
                        this.setState({ activeCaseData });
                    }
                }
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    selectPatient(patient, tab) {
        localStorage.setItem('patientId', patient.patientID);

        if (tab === 'first') {
            this.setState({ selectedPatientInfo: patient, searchQuery: '', filteredPatientsInfo: [] });
        } else if (tab === 'second') {
            this.setState({ selectedPatientProgression: patient, progressionSearchQuery: '', filteredPatientsProgression: [] });
        }
    }

    handleTabSelect(tabKey) {
        this.setState({
            activeTab: tabKey,
            // Reset search queries and filtered patients on tab switch
            searchQuery: '',
            progressionSearchQuery: '',
            filteredPatientsInfo: [],
            filteredPatientsProgression: []
        });
    }

    componentDidMount() {
        this.setState({ loaderModal: true });

        setTimeout(() => {
            this.getActiveCases();
            this.setState({ loaderModal: false });
        }, 1500);
    }

    render() {
        const { searchQuery, progressionSearchQuery, filteredPatientsInfo, filteredPatientsProgression, selectedPatientInfo, selectedPatientProgression, activeTab } = this.state;

        return (
            <div className="d-flex" id="wrapper">
                <Side />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Top />
                        <div className="container-fluid">
                            <div className="app-content">
                                <section className="section" id="accordion">
                                    <Row>
                                        <Col lg='12'>
                                            <Tab.Container id="left-tabs-example" activeKey={activeTab} onSelect={this.handleTabSelect}>
                                                <Row>
                                                    <Col lg='1'>
                                                        <div className="card" style={{ width: '120px' }}>
                                                            <div className="card-header">
                                                                <h3 className="font-weight-bold mb-0 text-black">Reports</h3>
                                                            </div>
                                                            <div className="card-body p-0" id="mycard-collapse">
                                                                <Nav variant="pills" className="flex-column list-group list-cyan">
                                                                    {/* <Nav.Item>
                                                                        <Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="first" onClick={this.getActiveCases}>
                                                                            <span><FaList className='mr-4' style={{ verticalAlign: "text-top" }} /></span>Information
                                                                        </Nav.Link>
                                                                    </Nav.Item> */}
                                                                    <Nav.Item>
                                                                        <Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="second" onClick={() => this.handleTabSelect('second')}>
                                                                            <span><FaList className='mr-4' style={{ verticalAlign: "text-top" }} /></span>Progression
                                                                        </Nav.Link>
                                                                    </Nav.Item>
                                                                </Nav>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col lg='11'>
                                                        <Tab.Content>
                                                            <Tab.Pane eventKey="first">
                                                                <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                                    <div className="card-body p-3">
                                                                        <Row className="mb-3">
                                                                            <Col lg='12'>
                                                                                <Form.Control 
                                                                                    type="text" 
                                                                                    placeholder="Search Analytics Report by Patient Name" 
                                                                                    value={searchQuery}
                                                                                    onChange={this.handleSearch}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                        {filteredPatientsInfo.length > 0 && (
                                                                            <Row>
                                                                                <Col lg='12'>
                                                                                    <div>
                                                                                        {filteredPatientsInfo.map(patient => (
                                                                                            <div key={patient.patientID} className="mb-2">
                                                                                                <p style={{ cursor: 'pointer' }} onClick={() => this.selectPatient(patient, 'first')}>Patient Name: {patient.name}</p>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        )}
                                                                        {selectedPatientInfo && (
                                                                            <Row>
                                                                                <Col lg='12'>
                                                                                    <AnalyticsReport patientId={selectedPatientInfo.patientID} />
                                                                                </Col>
                                                                            </Row>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey="second">
                                                                <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                                    <div className="card-body p-3">
                                                                        <Row className="mb-3">
                                                                            <Col lg='12'>
                                                                                <Form.Control 
                                                                                    type="text" 
                                                                                    placeholder="Search in Progression Report" 
                                                                                    value={progressionSearchQuery}
                                                                                    onChange={this.handleProgressionSearch}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                        {filteredPatientsProgression.length > 0 && (
                                                                            <Row>
                                                                                <Col lg='12'>
                                                                                    {filteredPatientsProgression.map(patient => (
                                                                                        <div key={patient.patientID} className="mb-2">
                                                                                            <p style={{ cursor: 'pointer' }} onClick={() => {
                                                                                                this.selectPatient(patient, 'second');
                                                                                                this.handleTabSelect('second');
                                                                                            }}>Patient Name: {patient.name}</p>
                                                                                        </div>
                                                                                    ))}
                                                                                </Col>
                                                                            </Row>
                                                                        )}
                                                                        {selectedPatientProgression && (
                                                                            <Row>
                                                                                <Col lg='12'>
                                                                                    <ProgressionReport patientId={selectedPatientProgression.patientID} />
                                                                                </Col>
                                                                            </Row>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </Tab.Pane>
                                                        </Tab.Content>
                                                    </Col>
                                                </Row>
                                            </Tab.Container>
                                        </Col>
                                    </Row>
                                </section>
                            </div>
                        </div>
                        <Loader show={this.state.loaderModal} />
                    </div>
                </div>
            </div>
        );
    }
}
